import React from 'react';

class ProgressBar extends React.Component {
	render() {
		return (
			<div style={{
	      height: 14,
	      width: (Math.round(this.props.percentage * 100)) + '%',
	      backgroundColor: '#0084FF'
	    }}>
	    </div> );
	}
}

export default ProgressBar;


// WEBPACK FOOTER //
// ./src/components/music/progressbar.jsx